import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const Moon = createIcon({
  displayName: 'Moon',
  viewBox: '0 0 14 14',
  path: (
    <path
      d="M8.3 1v.2C8.3 5.4 5.1 9 1 9.5c1 2 3.1 3.5 5.5 3.5 3.4 0 6.1-2.7 6.1-6.1 0-2.8-1.8-5.1-4.3-5.9z"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
  ),
})
